import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import webIcon from "../../../assets/images/web.svg";
import bannerIcon from "../../../assets/images/banner.svg";
import mobileIcon from "../../../assets/images/mobile.svg";
import facebookIcon from "../../../assets/images/facebook.svg";
import instagramIcon from "../../../assets/images/instagram.svg";
import dooh1080x1920Icon from "../../../assets/images/dooh_1080x1920.svg";
import dooh1920x1080Icon from "../../../assets/images/dooh_1920x1080.svg";
import dooh1400x400Icon from "../../../assets/images/dooh_1400x400.svg";
import dooh1280x960Icon from "../../../assets/images/dooh_1280x960.svg";
import televisionIcon from "../../../assets/images/television.png";

const propTypes = {
  placements: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedPlacement: PropTypes.string,
  onSelectPlacement: PropTypes.func.isRequired,
  productCode: PropTypes.string.isRequired
};

const getIconForPlacement = (placement, productCode) => {
  switch (placement) {
    case "preview_web":
      return webIcon;
    case "preview_video":
      return productCode === "ctv" ? televisionIcon : webIcon;
    case "preview_banner":
      return bannerIcon;
    case "preview_mobile":
      return mobileIcon;
    case "preview_facebook":
      return facebookIcon;
    case "preview_instagram":
      return instagramIcon;
    case "preview_dooh_1080x1920":
      return dooh1080x1920Icon;
    case "preview_dooh_1920x1080":
      return dooh1920x1080Icon;
    case "preview_dooh_1400x400":
      return dooh1400x400Icon;
    case "preview_dooh_1280x960":
      return dooh1280x960Icon;
    default:
      return null;
  }
};

const PlacementSelectors = ({
  placements,
  selectedPlacement = null,
  onSelectPlacement,
  productCode
}) => {
  return (
    <div className="ad-preview__placement-selectors">
      {placements.map(placement => (
        <button
          type="button"
          key={placement}
          className={classNames([
            `ad-preview__placement-selectors--${placement}`,
            placement === selectedPlacement ? "selected" : ""
          ])}
          onClick={() => onSelectPlacement(placement)}
        >
          <img
            src={getIconForPlacement(placement, productCode)}
            alt={`${placement} icon`}
            style={{ width: "24px", height: "24px" }}
          />
        </button>
      ))}
    </div>
  );
};

PlacementSelectors.propTypes = propTypes;

export default PlacementSelectors;
